import React, { useState, useEffect } from 'react';
import { Container, LoadingOverlay } from '@mantine/core';
import { useDispatch } from 'react-redux';
// import { getActivitiesQuery } from '../../../../src/slices/thunks';
import mockActivities from '../../../data/mockActivities.json';
import KanbanBoard from './Widgets/KanbanBoard';
import TaskModal from './Widgets/TaskModal';

const KanbanPage = () => {
    const dispatch = useDispatch();
    const [modalOpened, setModalOpened] = useState(false);
    const [selectedTask, setSelectedTask] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [activityData, setActivityData] = useState([]);
    

    const fetchActivityData = async () => {
        try {
            setIsLoading(true);
            
            // Usar datos mock en lugar del endpoint real
            const filteredData = mockActivities.filter(activity => activity.title && activity.title.trim() !== '');
            setActivityData(filteredData);
            
            // CÓDIGO COMENTADO - Endpoint real
            /*
            const queryPopulate = [
                'activity_status',
                'activity_group',
                'management',
                'supervisory_entity',
                'activity_type',
                'activity_priority',
                'user_info',
                'productive_cycle',
                'productive_cycle_stage',
                'establishment',
            ];
            
            const baseFilters = {
                disable: {
                    $eq: false,
                }
            };
            
            const queryParams = {
                populate: queryPopulate,
                filters: baseFilters,
                pagination: {
                    page: 1,
                    pageSize: 100 
                }
            };
            
            const result = await dispatch(getActivitiesQuery(queryParams)).unwrap();
            const data = result.data || result;
            
            // Filtrar solo actividades que tengan title (no null o vacío)
            const filteredData = data.filter(activity => activity.title && activity.title.trim() !== '');
            setActivityData(filteredData);
            */
            
        } catch (error) {
            console.error('Error fetching activity data:', error);
        } finally {
            setIsLoading(false);
        }
    };
    
    useEffect(() => {
        fetchActivityData();
    }, []);



    const handleTaskClick = (task) => {
        setSelectedTask(task);
        setModalOpened(true);
    };

    const handleModalClose = () => {
        setModalOpened(false);
        setSelectedTask(null);
    };

    return (
        <Container fluid style={{ position: 'relative', padding: '0px' }}>
            <LoadingOverlay visible={isLoading} />
            <KanbanBoard activityData={activityData} onTaskClick={handleTaskClick} />
            
            <TaskModal
                opened={modalOpened}
                onClose={handleModalClose}
                task={selectedTask}
            />
        </Container>
    );
};

export default KanbanPage;